import RelationsTable from 'components/RelationsTable';
import useEntities from 'hooks/useEntities';
import { entityColumnsToAntColumns } from 'utils/entityColumnsToAntColumns';

const PlayerGames = ({ gamesData }) => {
    const entities = useEntities();
    const sourceEntity = entities.Player;
    const targetEntity = entities.Game;

    return (
        <RelationsTable
            data={gamesData?.map(l => ({
                ...l?.Game,
                IsStar: l.IsStar,
                StatGoals: l.StatGoals,
                StatPoints: l.StatPoints,
                StatAssists: l.StatAssists,
                StatPenaltyMinutes: l.StatPenaltyMinutes,
                ListPosition_name: l.ListPosition?.name
            }))}
            sourceEntity={sourceEntity}
            targetEntity={targetEntity}
            columns={entityColumnsToAntColumns(targetEntity, [
                { column: 'StartDateTime-nowrap', defaultSortOrder: 'descend' },
                'Venue',
                'HomeTeam-nick',
                'Score',
                'AwayTeam-nick',
                'status',
                'timekeeper',
                'referee',
                {
                    title: 'Position',
                    render: (record) => record.ListPosition_name,
                },
                'PlayerStar',
                'PlayerGoals',
                'PlayerAssists',
                'PlayerPoints',
                'PlayerPenaltyMinutes',
                'PlayerSpecial',
            ])}
        />
    );
}

export default PlayerGames
